// apps/client/src/ui/chat/QuickPhrases.tsx (M0-T19) — the twelve one-tap phrases (strings chat.phrase1…12)
import type { StringKey } from '@whiskerton/content';
import { useT } from '../i18n';

export const PHRASES: readonly StringKey[] = Array.from({ length: 12 }, (_, i) => `chat.phrase${i + 1}` as StringKey);

export function QuickPhrases({ say }: { say: (text: string) => void }) {
  const t = useT();
  return (
    <div className="chat-phrases" role="group" aria-label={t('chat.quick')}>
      {PHRASES.map((key) => (
        <button key={key} type="button" className="pill chat-phrase" onClick={() => say(t(key))}>{t(key)}</button>
      ))}
    </div>
  );
}
